// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3RDdy","file":"styles_file__2L3wt"};